const STANDARD_EXPORT_FIELDS = Object.freeze({
  company: [
    ["id", "ID"],
    ["old_reference", "ncrm.importWizard.fields.oldReference"],
    ["name", "ncrm.importWizard.fields.companyName"],
    ["legal_name", "ncrm.importWizard.fields.legalName"],
    ["fiscal_code", "ncrm.importWizard.fields.fiscalCode"],
    ["vat_number", "ncrm.importWizard.fields.vatNumber"],
    ["registration_number", "ncrm.importWizard.fields.registrationNumber"],
    ["iban", "ncrm.importWizard.fields.iban"],
    ["business_category", "ncrm.importWizard.fields.businessCategory"],
    ["business_is_active", "ncrm.contacts.details.businessStatus.fieldLabel"],
    ["industry", "ncrm.importWizard.fields.industry"],
    ["company_size", "ncrm.importWizard.fields.companySize"],
    ["employees_count", "ncrm.importWizard.fields.employeesCount"],
    ["annual_revenue", "ncrm.importWizard.fields.annualRevenue"],
    ["mitp_founded_year", "ncrm.contacts.details.company.fields.mitpFoundedYear"],
    ["mitp_company_type", "ncrm.contacts.details.company.fields.mitpCompanyType"],
    ["mitp_employees_text", "ncrm.contacts.details.company.fields.mitpEmployeesText"],
    ["mitp_revenue_text", "ncrm.contacts.details.company.fields.mitpRevenueText"],
    ["mitp_last_synced_at", "ncrm.contacts.details.company.fields.mitpLastSyncedAt"],
    ["website", "ncrm.importWizard.fields.website"],
    ["email_primary", "ncrm.importWizard.fields.emailPrimary"],
    ["email_secondary", "ncrm.importWizard.fields.emailSecondary"],
    ["email_tertiary", "ncrm.importWizard.fields.emailTertiary"],
    ["email_primary_label", "ncrm.importWizard.fields.emailPrimaryLabel"],
    ["email_secondary_label", "ncrm.importWizard.fields.emailSecondaryLabel"],
    ["email_tertiary_label", "ncrm.importWizard.fields.emailTertiaryLabel"],
    ["phone_primary", "ncrm.importWizard.fields.phonePrimary"],
    ["phone_secondary", "ncrm.importWizard.fields.phoneSecondary"],
    ["phone_tertiary", "ncrm.importWizard.fields.phoneTertiary"],
    ["phone_primary_label", "ncrm.importWizard.fields.phonePrimaryLabel"],
    ["phone_secondary_label", "ncrm.importWizard.fields.phoneSecondaryLabel"],
    ["phone_tertiary_label", "ncrm.importWizard.fields.phoneTertiaryLabel"],
    ["address_text", "ncrm.importWizard.fields.addressText"],
    ["country", "ncrm.importWizard.fields.country"],
    ["linkedin", "ncrm.importWizard.fields.linkedin"],
    ["facebook", "ncrm.importWizard.fields.facebook"],
    ["instagram", "ncrm.importWizard.fields.instagram"],
    ["administrator_name", "ncrm.importWizard.fields.administratorName"],
    ["sales_manager_id", "ncrm.importWizard.fields.salesManagerId"],
    ["sales_manager_name", "ncrm.contacts.details.company.fields.salesManager"],
    ["source", "ncrm.importWizard.fields.source"],
    ["tags", "ncrm.importWizard.fields.tags"],
    ["notes", "ncrm.importWizard.fields.notes"],
    ["owner_user_id", "ncrm.importWizard.fields.ownerUserId"],
    ["owner_user_name", "ncrm.contacts.details.company.fields.ownerUser"],
    ["created_by_user_id", "ncrm.contacts.details.company.fields.createdByUser"],
    ["created_by_user_name", "ncrm.contacts.details.company.fields.createdByUser"],
    ["updated_by_user_id", "ncrm.contacts.details.company.fields.updatedByUser"],
    ["updated_by_user_name", "ncrm.contacts.details.company.fields.updatedByUser"],
    ["created_at", "ncrm.contacts.details.company.fields.createdAt"],
    ["updated_at", "ncrm.contacts.details.company.fields.updatedAt"],
  ],
  person: [
    ["id", "ID"],
    ["old_reference", "ncrm.importWizard.fields.oldReference"],
    ["ncrm_company_id", "ncrm.importWizard.fields.linkedCompanyId"],
    ["company_name", "ncrm.contacts.details.person.fields.companyName"],
    ["first_name", "ncrm.importWizard.fields.firstName"],
    ["last_name", "ncrm.importWizard.fields.lastName"],
    ["position", "ncrm.importWizard.fields.position"],
    ["department", "ncrm.importWizard.fields.department"],
    ["business_is_active", "ncrm.contacts.details.businessStatus.fieldLabel"],
    ["email_primary", "ncrm.importWizard.fields.emailPrimary"],
    ["email_secondary", "ncrm.importWizard.fields.emailSecondary"],
    ["email_tertiary", "ncrm.importWizard.fields.emailTertiary"],
    ["email_primary_label", "ncrm.importWizard.fields.emailPrimaryLabel"],
    ["email_secondary_label", "ncrm.importWizard.fields.emailSecondaryLabel"],
    ["email_tertiary_label", "ncrm.importWizard.fields.emailTertiaryLabel"],
    ["phone_primary", "ncrm.importWizard.fields.phonePrimary"],
    ["phone_secondary", "ncrm.importWizard.fields.phoneSecondary"],
    ["phone_tertiary", "ncrm.importWizard.fields.phoneTertiary"],
    ["phone_primary_label", "ncrm.importWizard.fields.phonePrimaryLabel"],
    ["phone_secondary_label", "ncrm.importWizard.fields.phoneSecondaryLabel"],
    ["phone_tertiary_label", "ncrm.importWizard.fields.phoneTertiaryLabel"],
    ["website", "ncrm.importWizard.fields.website"],
    ["linkedin", "ncrm.importWizard.fields.linkedin"],
    ["facebook", "ncrm.importWizard.fields.facebook"],
    ["instagram", "ncrm.importWizard.fields.instagram"],
    ["address_text", "ncrm.importWizard.fields.addressText"],
    ["country", "ncrm.importWizard.fields.country"],
    ["source", "ncrm.importWizard.fields.source"],
    ["tags", "ncrm.importWizard.fields.tags"],
    ["notes", "ncrm.importWizard.fields.notes"],
    ["owner_user_id", "ncrm.importWizard.fields.ownerUserId"],
    ["owner_user_name", "ncrm.contacts.details.person.fields.ownerUser"],
    ["created_by_user_id", "ncrm.contacts.details.person.fields.createdByUser"],
    ["created_by_user_name", "ncrm.contacts.details.person.fields.createdByUser"],
    ["updated_by_user_id", "ncrm.contacts.details.person.fields.updatedByUser"],
    ["updated_by_user_name", "ncrm.contacts.details.person.fields.updatedByUser"],
    ["created_at", "ncrm.contacts.details.person.fields.createdAt"],
    ["updated_at", "ncrm.contacts.details.person.fields.updatedAt"],
  ],
});

const normalizeExportType = (value) => (value === "person" ? "person" : "company");

const normalizeExportValue = (value) => {
  if (value === null || value === undefined) return "";
  if (value instanceof Date) return value.toISOString();
  if (typeof value === "boolean") return value ? "true" : "false";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (_) {
      return String(value);
    }
  }
  return String(value);
};

const hasExportValue = (value) => normalizeExportValue(value).trim().length > 0;

const translateLabel = (labelKey, translate) => {
  if (!labelKey) return "";
  if (typeof translate !== "function") return labelKey;
  const translated = translate(labelKey);
  return translated && translated !== labelKey ? translated : labelKey;
};

const normalizeCustomFieldKey = (entry) => {
  const explicitKey = String(entry?.key || "").trim();
  if (explicitKey) return `custom:${explicitKey}`;
  const definitionId = String(entry?.field_definition_id || "").trim();
  return definitionId ? `custom:id:${definitionId}` : "";
};

const collectCustomFieldColumns = (records = []) => {
  const columns = [];
  const seen = new Set();
  records.forEach((record) => {
    (record?.custom_fields || []).forEach((entry) => {
      const key = normalizeCustomFieldKey(entry);
      if (!key || seen.has(key) || !hasExportValue(entry?.value_text)) return;
      seen.add(key);
      columns.push({
        key,
        label: entry?.label ? `Custom: ${entry.label}` : key,
        custom: true,
      });
    });
  });
  return columns;
};

const buildExportColumns = ({ type, records, translate }) => {
  const normalizedType = normalizeExportType(type);
  const standardColumns = (STANDARD_EXPORT_FIELDS[normalizedType] || []).map(([key, labelKey]) => ({
    key,
    label: translateLabel(labelKey, translate),
  }));
  const customColumns = collectCustomFieldColumns(records);
  return [...standardColumns, ...customColumns].filter((column) =>
    records.some((record) => hasExportValue(resolveExportCellValue(record, column)))
  );
};

export const resolveExportCellValue = (record, column) => {
  if (!column?.custom) return record?.[column?.key];
  const customField = (record?.custom_fields || []).find(
    (entry) => normalizeCustomFieldKey(entry) === column.key
  );
  return customField?.value_text;
};

export const buildContactExportCsv = ({ type, records, translate } = {}) => {
  const safeRecords = Array.isArray(records) ? records : [];
  const columns = buildExportColumns({ type, records: safeRecords, translate });
  const lines = [
    columns.map((column) => escapeCsvCell(column.label)).join(","),
    ...safeRecords.map((record) =>
      columns
        .map((column) => escapeCsvCell(normalizeExportValue(resolveExportCellValue(record, column))))
        .join(",")
    ),
  ];
  return {
    columns,
    csv: lines.join("\r\n"),
  };
};

export const escapeCsvCell = (value) => {
  const normalized = normalizeExportValue(value);
  const safeValue = /^[\t\r]|^\s*[=+\-@]/.test(normalized) ? `'${normalized}` : normalized;
  if (!/[",\r\n]/.test(safeValue)) return safeValue;
  return `"${safeValue.replace(/"/g, '""')}"`;
};
